import React from "react";

import { withStockPage } from "../lib/StockPage";

/**
 * Maps StockPage context into the legacy prop names used by StockPage class components.
 */
export default function withStockPageAsLegacyProps(WrappedComponent) {
  @withStockPage
  class WithStockPageAsLegacyProps extends React.Component {
    render() {
      const {
        pageData,
        stock,
        hasMediaMonitor,
        stockTags,
        priceAlerts,
        financialSituation,
        recommendations,
        hasMoreRecommendations,
        moreRecommendationsLoading,
        loadMoreRecommendations,
        reloadPriceAlerts,
        reloadTags,
        stockId,
        stockName,
        market,
        ticker,
        active,
        ...rest
      } = this.props;

      const stockPayload = stock?.data || null;
      const pagePayload = pageData?.data || null;

      return (
        <WrappedComponent
          {...rest}
          market={market}
          ticker={ticker}
          active={active}
          stockId={stockId}
          stockName={stockName}
          stockData={pagePayload}
          stockDataLoading={Boolean(pageData?.loading)}
          stockDataErrorResponse={pageData?.error}
          stock={stockPayload}
          stockLoading={Boolean(stock?.loading)}
          stockError={stock?.error}
          stockBasicInfoSource={stockPayload}
          hasMediaMonitor={Boolean(hasMediaMonitor)}
          stockTags={{
            data: stockTags?.data || [],
            loading: Boolean(stockTags?.loading),
            error: stockTags?.error
          }}
          priceAlerts={priceAlerts?.data || []}
          priceAlertsLoading={Boolean(priceAlerts?.loading)}
          fetchPriceAlerts={reloadPriceAlerts}
          reloadPriceAlerts={reloadPriceAlerts}
          reloadTags={reloadTags}
          financialSituationData={financialSituation?.data}
          financialSituationLoading={Boolean(financialSituation?.loading)}
          recommendations={recommendations?.data || []}
          recommendationsLoading={Boolean(recommendations?.loading)}
          hasMoreStockRecommendations={hasMoreRecommendations}
          moreRecommendationsLoading={moreRecommendationsLoading}
          fetchMoreStockRecommendations={loadMoreRecommendations}
          loadMoreRecommendations={loadMoreRecommendations}
        />
      );
    }
  }

  return WithStockPageAsLegacyProps;
}
